module.exports = __webpack_public_path__ + "img/20200508144723759.e773d556.png";